import React from 'react';
import { useParams } from 'react-router';
import PageContainer from '../../../Components/PageContainer/PageContainer';
import Sidebar from '../../../Components/Sidebar/Sidebar';
import { useProducerPage } from './hook';
import { PRODUCER_SIDEBAR_SECTIONS, USER_PERMISSIONS } from '../../../constants/types';
import { validateUserRole } from '../../../utils/utils';

import { useAuth } from '../../../Providers/AuthProvider/AuthProvider';

const ProducerPage = () => {
  const { producerId } = useParams();
  const { sections, producer } = useProducerPage(producerId);
  const { user } = useAuth();
  const isSuperAdmin = validateUserRole(user.role, USER_PERMISSIONS.SUPER_ADMIN);
  const isAdmin = validateUserRole(user.role, USER_PERMISSIONS.ADMIN);

  const footerUrl = isSuperAdmin ? '/backoffice/admin' : '/backoffice/productoras';

  const initialSection = isAdmin
    ? PRODUCER_SIDEBAR_SECTIONS.DASHBOARD
    : PRODUCER_SIDEBAR_SECTIONS.ACTIVE_EVENTS;

  return (
    <PageContainer withPaddingTop={0} title={`Backoffice - ${producer?.name}`}>
      {producer && (
        <Sidebar
          sections={sections}
          producerId={producerId}
          headerLabel={producer.name}
          footerUrlLabel="Ver productoras"
          footerUrl={footerUrl}
          initialSection={initialSection}
        />
      )}
    </PageContainer>
  );
};

export default ProducerPage;
